import AccessManagement from "./access-management";
import UserManagement from "./management";

const modules = [AccessManagement, UserManagement];

export default modules;
